import styles from './SkeletonCoverCard.module.scss';
import Skeleton from 'react-loading-skeleton';

type Props = {
  isPopular?: boolean | false;
  isDark?: boolean | false;
}

function SkeletonCoverCard(props: Props) {

  const { isPopular, isDark } = props;

  return (
    <div className={styles.newCoverCard} style={{opacity: isDark ? '40%' : '60%'}}>
      <Skeleton height={120} borderRadius={10} baseColor="#D8D8D8"/>
      {!isPopular && <Skeleton height={14} borderRadius={10} style={{marginTop: 15}} baseColor="#D8D8D8"/>}
      <div className={styles.bottomView}>
        <Skeleton height={21} borderRadius={10} style={{width: '90%'}} baseColor="#D8D8D8"/>
        {!isPopular && <>
        <Skeleton height={15} borderRadius={10} style={{width: '60%', marginTop: '14px'}} baseColor="#D8D8D8"/>
        <Skeleton height={2} containerClassName={styles.divider} baseColor="#D8D8D8"/>
        <div className={styles.doubleView}>
          <Skeleton height={21} borderRadius={10} containerClassName={styles.smallOneView} style={{width: '100%'}} baseColor="#D8D8D8"/>
          <Skeleton height={21} borderRadius={10} containerClassName={styles.smallOneView} style={{width: '100%'}} baseColor="#D8D8D8"/>
        </div>
        <Skeleton height={21} borderRadius={10} style={{width: '27%', marginTop: 5}} baseColor="#D8D8D8"/>
        </>}
      </div>
    </div>
  );
}

export default SkeletonCoverCard

